import { createFileRoute } from '@tanstack/react-router';
import RouteCreate from '~/containers/RouteCreate';

export const Route = createFileRoute('/trolley-routes/new')({
  component: RouteCreate,
});
